import React from "react";
import { StyledFooter, StyledLink } from "./styled";

const Footer = () => {
  return <StyledFooter>made by <StyledLink href="https://kamila-duda.github.io/" target="_blank">Kamila Duda</StyledLink></StyledFooter>;
};

export default Footer;
